
class yieldlockRegister {

    static values = {};

    static setValue(key, value){
        try {
            if(sessionStorage.getItem('yieldlock-values')){
                yieldlockRegister.values = JSON.parse(sessionStorage.getItem('yieldlock-values'));
            }
            yieldlockRegister.values[key] = value;
            sessionStorage.setItem('yieldlock-values', JSON.stringify(yieldlockRegister.values));
        }catch (e) {}
    }

    static getValue(key){
        try {
            if(sessionStorage.getItem('yieldlock-values')){
                let values = JSON.parse(sessionStorage.getItem('yieldlock-values'));
                return values[key];
            }else{
                return yieldlockRegister.values[key];
            }
        }catch (e) {
            return yieldlockRegister.values[key];
        }
    }

    static removeValue(key){
        delete yieldlockRegister.values[key];
        try {
            if(sessionStorage.getItem('yieldlock-values')){
                let values = JSON.parse(sessionStorage.getItem('yieldlock-values'));
                delete values[key];
                sessionStorage.setItem('yieldlock-values', JSON.stringify(values));
            }
        }catch (e) {}
    }

    static remove(){
        try {
            sessionStorage.removeItem('yieldlock-values');
        }catch (e) {}
        yieldlockRegister.values = {};
    }

}

export {yieldlockRegister}


// WEBPACK FOOTER //
// ./src/services/yieldlockRegister.js